export const checkautoCompanyAllListKey = 'checkautoCompanyAllList';
export const companyAllKey = 'companyAll';
export const companyAllListKey = 'companyAllList';
export const companyKey = 'company';
export const companyListKey = 'companyList';
export const editCompanyKey = 'editCompany';
export const deleteCompanyKey = 'deleteCompany';
export const addCompanyKey = 'addCompany';
export const advertsListKey = 'advertsList';
